import React from 'react';
import { Routes, Route } from 'react-router-dom';  // No need for BrowserRouter here
import Header from './Header'; // Import Header component
import Home from './Home';
import Footer from './Footer';

import './assets/css/vendor/animate.min.css';
import './assets/css/vendor/remixicon.css';
import './assets/css/demo-2.css';
import './assets/css/style.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GoldRoom from './GoldRoom';
import Gallery from './Gallery';
import './App.css';

import About from './About';
import PginPune from './keywordPage/PginPune';
import SingleRoominpg from './keywordPage/SingleRoominpg';
import PginKharadi from './keywordPage/PginKharadi';
import BestLuxuarypginpune from './keywordPage/BestLuxuarypginpune';
import BestpgnearEonITPark from './keywordPage/BestpgnearEonITPark';
import HostelinKharadi from './keywordPage/HostelinKharadi';
import Omsaipgkharadi from './keywordPage/Omsaipgkharadi';
import PayingGuestInKharadi from './keywordPage/PayingGuestInkharadi';
import OmSaiPGMaleInKharadi from './keywordPage/OmSaiPGMaleInKharadi';
import HotelsInKharadi from './keywordPage/HotelsInKharadi';
import PginChandanNagar from './keywordPage/PginChandanNagar';
import PayingguestChandannager from './keywordPage/PayingguestChandannager';
import GirlsHotelsInKharadi from './keywordPage/GirlsHotelsInKharadi';
import BoysHostelInKharadi from './keywordPage/BoysHostelInKharadi';
import MonthlyBasisPginKharadi from './keywordPage/MonthlyBasisPginKharadi';
import Pginwagholi from './keywordPage/Pginwagholi';
import Pginkharadiwithfood from './keywordPage/Pginkharadiwithfood';
import HostelsInPune from './keywordPage/HostelsInPune';
import PgforstudentinKharadi from './keywordPage/PgforstudentinKharadi';
import Pgforworkingprofessional from './keywordPage/Pgforworkingprofessional';
import Luxurypginkharadi from './keywordPage/Luxurypginkharadi';
import PayingGuestnearkharadiITPark from './keywordPage/PayingGuestnearkharadiITPark';
import PayingGuestnearEonITPark from './keywordPage/PayingGuestnearEonITPark';
import Pgnearkharadibypass from './keywordPage/Pgnearkharadibypass';
import WadgoanSheriPg from './keywordPage/WadgoanSheriPg';
import ScrollToTop from './ScrollToTop';
import Terms from './Terms';
import Policy from './Policy';
import Amenities from './Amenities';
import TerrifPlan from './TerrifPlan';
import PGinkharadiforladies from './keywordPage/PGinkharadiforladies';
import Service from './Service';
import EnquiryForm from './EnquiryForm';
import ContactForm from './ContactForm';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <>
    <Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 | Om Sai PG |Home | Hostels in Pune | PG for Students in Kharadi Pune | Paying Guest Hostel in Chandan Nagar
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="PG in Pune, PG in Kharadi, Hostels in Pune,PG for Students in Kharadi Pune, Paying Guest Hostel in Chandan Nagar"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

      <div>
        <ScrollToTop />
        <Header /> {/* The Header will be displayed on all pages */}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/room" element={<GoldRoom />} />
          <Route path="/Gallery" element={<Gallery />} />
          
          <Route path="/about" element={<About />} />
          <Route path="/PG-In-Pune" element={<PginPune />} />
          <Route path="/Single-Room-PG-in-Pune" element={<SingleRoominpg />} />
          <Route path="/PG-in-Kharadi" element={<PginKharadi />} />
          <Route path="/Best-Luxury-PG-in-Pune" element={<BestLuxuarypginpune />} />
          <Route path="/PG-in-kharadi-for-female" element={<PGinkharadiforladies></PGinkharadiforladies>} />
          <Route path="/Best-PG-Near-Eon-IT-Park-Kharadi" element={<BestpgnearEonITPark />} />
          <Route path="/Hostel-in-Kharadi" element={<HostelinKharadi />} />
          <Route path='/Om-Sai-PG-Kharadi' element={<Omsaipgkharadi />} />
          <Route path='/Paying-Guest-in-Kharadi' element={<PayingGuestInKharadi />} />
          <Route path='/PG-in-Kharadi-for-male' element={<OmSaiPGMaleInKharadi />} />
          <Route path='/Hostels-in-Kharadi' element={<HotelsInKharadi />} />
          <Route path='/PG-in-Chandan-Nagar' element={<PginChandanNagar />} />
          <Route path='/Paying-Guest-Hostel-in-Chandan-Nagar' element={<PayingguestChandannager />} />
          <Route path='/Girls-Hostels-in-Kharadi' element={<GirlsHotelsInKharadi />} />
          <Route path='/Boys-Hostel-in-Kharadi' element={<BoysHostelInKharadi />} />
          <Route path='/Monthly-Basis-PG-in-Kharadi' element={<MonthlyBasisPginKharadi />} />
          <Route path='/Pg-in-Wagholi' element={<Pginwagholi />} />
          <Route path='/PG-in-Kharadi-With-Food' element={<Pginkharadiwithfood />} />
          <Route path='/Hostels-in-Pune' element={<HostelsInPune />} />
          <Route path='/PG-for-Students-in-Kharadi-Pune' element={<PgforstudentinKharadi />} />
          <Route path='/PG-for-Working-Professionals-Pune' element={<Pgforworkingprofessional />} />
          <Route path='/Luxury-PG-in-Kharadi' element={<Luxurypginkharadi />} />
          <Route path='/Paying-Guest-Near-Kharadi-IT-Park-Pune' element={<PayingGuestnearkharadiITPark />} />
          <Route path='/PG-Near-Kharadi-Eon-IT-Park' element={<PayingGuestnearEonITPark />} />
          <Route path='/PG-Near-Kharadi-Bypass' element={<Pgnearkharadibypass />} />
          <Route path='/Wadgaon-Sheri-PG' element={<WadgoanSheriPg />} />

          {/* =================== */}
          <Route path='/Terms-and-condition' element={<Terms />} />
          <Route path='/privacy-and-policy' element={<Policy />} />
          <Route path='/amenities' element={<Amenities />} />
          <Route path='/Teriff-plan' element={<TerrifPlan />} />
          <Route path='/Services' element={<Service></Service>} />
          <Route path='/enquiry' element={<EnquiryForm></EnquiryForm>}></Route>
          <Route path='/contact' element={<ContactForm></ContactForm>}></Route>

        </Routes>
      </div>

      <Footer />
    </>
  );
}

export default App;
